import * as types from 'generated/graphql';

import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';
import { Reference } from '@apollo/client';


export const DailyReport: ITypeSpecificPolicy<types.DailyReport> = {
  fields: {
    approvedAt: dateTimeFieldPolicy(),
    reportDate: dateTimeFieldPolicy(),
    numberOfInspections: {
      read: (existing, { readField }) => {
        const inspections = readField<Reference[]>('inspections');

        return inspections?.length ?? 0;

      }
    },
    numberOfIncidents: {
      read: (existing, { readField }) => {
        const accidents = readField<Reference[]>('incidents');

        return accidents?.length ?? 0;

      }
    },
    numberOfDeliveries: {
      read: (existing, { readField }) => {
        const deliveries = readField<Reference[]>('deliveries');

        return deliveries?.length ?? 0;

      }
    },
    numberOfWorkEvents: {
      read: (existing, { readField }) => {
        const events = readField<Reference[]>('workLog');
        return events?.length ?? 0;

      }
    }
  }
};
